import {
  SyncDateWindow,
  type SyncDateWindowConstructor,
} from '../SyncDateWindow'

export interface QuickBooksSyncSettingsConstructor {
  purchaseOrder: SyncDateWindowConstructor
  expense: SyncDateWindowConstructor // UI label: "Bills"
}

export class QuickBooksSyncSettings {
  readonly purchaseOrder: SyncDateWindow
  readonly expense: SyncDateWindow

  constructor(data: QuickBooksSyncSettingsConstructor) {
    this.purchaseOrder = new SyncDateWindow(data.purchaseOrder)
    this.expense = new SyncDateWindow(data.expense)
  }

  // The Import/Export form and the Bills export page label the expense
  // window "Bills" (approved bills derive from expense reports).
  get bills(): SyncDateWindow {
    return this.expense
  }
}
